/* @flow */

import { useSelector } from 'react-redux';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';

export default function useAuthenticationToken(): ?string {
  return useSelector(getAuthenticationToken);
}
